import React from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const StyledBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #fff;
  font-family: "Rethink-Sans-Regular", sans-serif;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

interface BackButtonProps {
  onClick?: () => void;
  style?: React.CSSProperties;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, style }) => (
  <StyledBackButton onClick={onClick} style={style}>
    <FontAwesomeIcon icon={faArrowLeft} fontSize={14} color="#fff" />
    <span>Back</span>
  </StyledBackButton>
);

export default BackButton;
